import styled from 'styled-components'
import { colors } from '../../styles/colors'

export const PopupBox = styled.div`
    width: 100%;
    max-width: 940px;
    padding: 2.5rem 12.5rem 5rem 12.5rem;
    background: ${colors.dark_blue};
    box-shadow: -16px 16px 6px rgba(0, 0, 0, 0.4);

    position: relative;

    @media (min-width: 321px) and (max-width: 767.98px) {
        padding: 10rem 5rem;
    }
    @media (max-width: 320px) {
        padding: 10rem 2rem;
    }

    // INCLUDED CLASSES:

    > div > .cross-button {
        top: 5rem;
        right: 5rem;
    }
`
